import { useEffect } from 'react';

function RedirectWintripjapan() {

  useEffect(() => {
    const targetUrl = `https://winatriptojapan.my.canva.site/`;
    window.location.href = targetUrl;
  }, []);

  return (
    <div></div>
  );
}

export default RedirectWintripjapan;
